module.exports = __webpack_public_path__ + "static/media/media.8de47fd6.jpg";